import * as React from 'react';
import type { RowSelectionState } from '@tanstack/react-table';
import type {
  FindingsGroupBy,
  FindingsSort,
  FindingsView,
} from './findings-url';
import type { AutofixResult, FindingDoc } from './findings-types';

export type FindingsRowStaticContextValue = {
  activeView: FindingsView;
  groupBy: FindingsGroupBy;
  sortBy: FindingsSort;
  readOnly: boolean;
  canCreateAutofix: boolean;
  canCreateIssue: boolean;
  canCreateWaiver: boolean;
  repoFullName?: string;
  repoRef?: string;
  toggleSort: (col: FindingsSort) => void;
  copy: (text: string) => void;
  fix: (id: string) => void;
  ignore: (finding: FindingDoc) => void;
  reopen: (id: string) => void;
  createIssue: (finding: FindingDoc) => void;
  inspect: (finding: FindingDoc) => void;
  selection: {
    setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>;
    lastClickedIndexRef: React.MutableRefObject<number | null>;
    skipNextCheckedChangeRef: React.MutableRefObject<boolean>;
  };
};

export const FindingsRowStaticContext =
  React.createContext<FindingsRowStaticContextValue | null>(null);

export function useFindingsRowStatic(): FindingsRowStaticContextValue {
  const ctx = React.useContext(FindingsRowStaticContext);
  if (!ctx) throw new Error('FindingsRowStaticContext is missing');
  return ctx;
}

export type FindingsActionContextValue = {
  fixLoading: boolean;
  fixResult: AutofixResult | null;
  issueLoading: boolean;
};

export const FindingsActionContext =
  React.createContext<FindingsActionContextValue | null>(null);

export function useFindingsAction(): FindingsActionContextValue {
  const ctx = React.useContext(FindingsActionContext);
  if (!ctx) throw new Error('FindingsActionContext is missing');
  return ctx;
}
